export const SEARCH_ICON_SVG = `
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.03488 11.6992H5.24488L0.254883 16.6992L1.74488 18.1892L6.74488 13.1992V12.4092L7.01488 12.1292C8.15488 13.1092 9.63488 13.6992 11.2449 13.6992C14.8349 13.6992 17.7449 10.7892 17.7449 7.19922C17.7449 3.60922 14.8349 0.699219 11.2449 0.699219C7.65488 0.699219 4.74488 3.60922 4.74488 7.19922C4.74488 8.80922 5.33488 10.2892 6.31488 11.4292L6.03488 11.6992ZM15.7449 7.19922C15.7449 9.68922 13.7349 11.6992 11.2449 11.6992C8.75488 11.6992 6.74488 9.68922 6.74488 7.19922C6.74488 4.70922 8.75488 2.69922 11.2449 2.69922C13.7349 2.69922 15.7449 4.70922 15.7449 7.19922Z" fill="#BBBEC0"/>
    </svg>
`;

export interface MultiSelectDefaults {
    layout: 'tags' | 'columns';
    searchable: boolean;
    showTags: boolean;
    showCheckboxes: boolean;
    placeholder: string | null;
    countText: string;
    clearText: string;
    maxSelected: number | null;
    maxSelectedMessage: string;
    availableLabel: string;
    selectedLabel: string;
    sortable: boolean;
    creatable: boolean;
    creatableText: string;
}

export const DEFAULTS: MultiSelectDefaults = {
    layout: 'tags',
    searchable: false,
    showTags: true,
    showCheckboxes: true,
    placeholder: null,
    countText: 'Selected options: {count}',
    clearText: 'Clear',
    maxSelected: null,
    maxSelectedMessage: 'Maximum {max} items can be selected',
    availableLabel: 'Available',
    selectedLabel: 'Selected',
    sortable: false,
    creatable: false,
    creatableText: 'Add "{value}"',
};